// src/components/ProjectCard.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt } from 'react-icons/fa';
import './ProjectCard.css';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
};

export default function ProjectCard({ project, index = 0 }) {
  return (
    <motion.div
      className="project-card card"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeUp}
      transition={{ delay: index * 0.08 }}
    >
      <Link to={`/projects/${project.slug}`} className="project-card-link">
        <h3 className="project-card-title">{project.title}</h3>
        <p className="project-card-tagline">{project.tagline}</p>
      </Link>

      <div className="project-card-tags">
        {project.tech.map((t) => (
          <span key={t} className="tech-tag">{t}</span>
        ))}
      </div>

      <div className="project-card-links">
        <Link to={`/projects/${project.slug}`} className="project-card-case-study">
          Read case study →
        </Link>
        {project.demoLink && (
          <div className="project-card-icons">
            <a href={project.demoLink} target="_blank" rel="noopener noreferrer" aria-label={`${project.title} live demo`}>
              <FaExternalLinkAlt />
            </a>
          </div>
        )}
      </div>
    </motion.div>
  );
}
